import React from 'react'
import { Row, Col } from 'antd';
import { useMediaQuery } from 'react-responsive'
import { ProductList } from 'Layout_v1';
import { Carousel, CarouselItem, Avatar, Loader } from 'Common/components'



export const Home = props => {
    const { loading, banners, products } = props;
    const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' })
    // const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

    var top_slider;
    var top_banner;
    var mid_banner;
    var bottom_banner;

    if (!loading && banners) {
        top_slider = banners.find(o => o.key == "top-slider")?.banner; //?.items;
        top_banner = banners.find(o => o.key == "top-banner")?.banner; //?.items;
        mid_banner = banners.find(o => o.key == "mid-banner")?.banner; //?.items;
        bottom_banner = banners.find(o => o.key == "bottom-banner")?.banner; //?.items;

    }


    var featured_products;
    var top_products;

    if (loading) return <Loader loading={true} />

    if (!loading && products) {
        featured_products = products.find(o => o.key =='featured-products')
        top_products = products.find(o => o.key == 'top-products')
    }

    return (
        <>
            {/* <HomePageHeader banners={top_slider} /> */}
            {top_slider &&
                <Carousel style={{ margin: "20px 0" }}>
                {top_slider?.items.map((item, i) => {
                    return <CarouselItem style={{ height: top_slider.height ? `${top_slider.height}px` : "auto"}} url={item.url} img={`${process.env.REACT_APP_DATA_URL}/${item.img}`} key={`${i}_${item._id}`} />
                    })}
                </Carousel>
            }

            {/* {top_banner && top_banner[0] && <img src={top_banner[0].img} width="100%" style={{ margin: '20px 0' }} /> } */}
            {top_banner && <>
                <Carousel style={{ margin: '20px 0' }}>
                    {top_banner?.items.map((item, i) => {
                        return <CarouselItem style={{ height: top_banner.height ? `${top_banner.height}px` : "auto" }} url={item.url} img={`${process.env.REACT_APP_DATA_URL}/${item.img}`} key={`${i}_${item._id}`} />
                        // return <div key={`${i}_${item._id}`}><a href={item.url}><img width="100%" src={item.img} /></a></div>
                    })}
                </Carousel>
            </>}

            {featured_products &&
                <div style={{ padding: "0 10px 20px 10px" }}>
                    <h3>{featured_products.title}</h3>
                    <ProductList data={featured_products.products} total={featured_products?.products?.length} />
                    {/* <ProductListScroller data={featured_products.products} hideScrollbar /> */}
                </div>
            }

            {/* {mid_banner && mid_banner[0] &&
                <div style={{ backgroundColor: "green", margin: "20px 0", minHeight: "50px" }}><img src={mid_banner[0].img} width="100%" /></div>
            } */}
            {mid_banner &&
                <Carousel style={{ margin: "20px 0" }}>
                    {mid_banner?.items.map((item, i) => {
                        return <CarouselItem style={{ height: mid_banner.height ? `${mid_banner.height}px` : "auto" }} url={item.url} img={`${process.env.REACT_APP_DATA_URL}/${item.img}`} key={`${i}_${item._id}`} />
                        // return <div key={`${i}_${item._id}`}><a href={item.url}><img src={item.img} /></a></div>
                    })}
                </Carousel>
            }

            {top_products &&
                <div style={{ padding: "20px 10px 20px 10px" }}>
                    <h3>{top_products.title}</h3>
                    {/* <ProductListScroller data={top_products.products} hideScrollbar /> */}
                    <ProductList data={top_products.products} total={top_products?.products?.length} />
                </div>
            }

            {bottom_banner &&
                <div style={{ padding: "0 0 20px 0" }}>
                    <Row gutter={[12, 0]}>
                        {bottom_banner && bottom_banner[0] &&
                            <Col span={isTabletOrMobileDevice ? 24 : 12} flex="auto"><div style={{ backgroundColor: "green", margin: "20px 0", minHeight: "50px" }}>
                                <a href={bottom_banner[0].url}><img src={`${process.env.REACT_APP_DATA_URL}/${bottom_banner[0].img}`} width="100%" /></a>
                            </div></Col>
                        }
                        {bottom_banner && bottom_banner[1] &&
                            <Col flex="auto"><div style={{ backgroundColor: "green", margin: "20px 0", minHeight: "50px" }}>
                                <a href={bottom_banner[1].url}><img src={`${process.env.REACT_APP_DATA_URL}/${bottom_banner[1].img}`} width="100%" /></a>
                            </div></Col>
                        }
                    </Row>
                </div>
            }

            {/* <BackToTopButton /> */}

        </>
    )
}

export default Home;